module.exports = __webpack_public_path__ + "img/default-code.9b94cd2e.png";